<template>
  <div class="k-page-content" v-loading="loading">
    <el-tabs v-model="activeName" class="box-eltab">
      <el-tab-pane label="用户组" name="first">
        <div class="k-page-common">
          <div class="k-common-header">
            <div class="k-filter-option k-filter-input" style="margin-bottom:0;">
              <el-form :inline="true" :model="searchForm" size="mini" ref="searchForm" :rules="rules.searchForm">
                <el-form-item label="查询类型" prop="type">
                  <el-select v-model="searchForm.type" placeholder="请选择查询类型">
                    <el-option label="用户组名称" value="name"></el-option>
                    <el-option label="用户组等级" value="level"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="用户组名称" prop="name" v-show="searchForm.type == 'name'">
                  <el-input v-model="searchForm.name" placeholder="请填写用户组名称"></el-input>
                </el-form-item>
                <el-form-item label="版本号" prop="level" v-show="searchForm.type == 'level'">
                  <el-select v-model="searchForm.level" placeholder="请选择用户组等级" clearable>
                    <el-option label="一级分类" value="LEVEL_ONE"></el-option>
                    <el-option label="二级分类" value="LEVEL_TWO"></el-option>
                    <el-option label="三级分类" value="LEVEL_THREE"></el-option>
                    <el-option label="四级分类" value="LEVEL_FOUR"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="doSearch">查询</el-button>
                  <el-button type="primary" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="k-common-con">
            <div class="k-table-wrapper">
              <div class="k-table-toolbar" style="margin-top:0;">
                <div>
                  <el-button type="primary" size="mini" @click="handelAddOpen">添加用户组</el-button>
                </div>
              </div>
              <div class="k-table-con">
                <el-table :data="tableData.data" style="width: 100%" border stripe ref="table" highlight-current-row
                  @sort-change="sortChange" :height="tableHeight">
                  <el-table-column fixed prop="name" label="用户组名称" width="200"></el-table-column>
                  <el-table-column prop="level_text" label="等级分类" width="200"></el-table-column>
                  <el-table-column prop="status_text" label="用户组状态" width="100"></el-table-column>
                  <el-table-column prop="create_time" label="创建时间" width="200" sortable="custom"></el-table-column>
                  <el-table-column prop="update_time" label="修改时间" width="200" sortable="custom"></el-table-column>
                  <el-table-column fixed="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                      <el-button @click="handleTableRolesOpen(scope.row)" type="text" size="small">角色</el-button>
                      <el-button @click="handleTableEditOpen(scope.row)" type="text" size="small">编辑</el-button>
                      <el-button @click="handleTableDelete(scope.row)" type="text" size="small"
                        class="c-danger">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination background ref="pagination" @current-change="handleCurrentChange"
                  :current-page="tableData.current_page | number" :page-size="tableData.per_page | number"
                  layout="total, prev, pager, next, jumper" :total="tableData.total | number"></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" size="40%">
      <el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px">
        <div class="drawer-header">
          <div class="header-title">
            <span>添加用户组</span>
            <i class="el-icon-close k-drawer-close" @click="addFormVisiable = false"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="用户组名称" prop="name">
            <el-input v-model="addForm.name" placeholder="请填写用户组名称"></el-input>
          </el-form-item>
          <el-form-item label="用户组等级" prop="level">
            <el-select v-model="addForm.level" placeholder="请选择用户组等级">
              <el-option label="一级分类" value="LEVEL_ONE"></el-option>
              <el-option label="二级分类" value="LEVEL_TWO"></el-option>
              <el-option label="三级分类" value="LEVEL_THREE"></el-option>
              <el-option label="四级分类" value="LEVEL_FOUR"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关联用户组" prop="pid">
            <el-select v-model="addForm.pid" placeholder="请选择关联用户组">
              <el-option label="顶级用户组" value="0"></el-option>
              <el-option v-for="item in groups_options" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否开启" prop="status">
            <el-radio v-model="addForm.status" label="STATUS_NORMAL">正常</el-radio>
            <el-radio v-model="addForm.status" label="STATUS_CLOSE">关闭</el-radio>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" @click="handelAdd" :size="size">提交</el-button>
          <el-button :size="size" @click="addFormVisiable = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer custom-class="k-drawer" :visible.sync="editFormVisiable" direction="rtl" size="40%">
      <el-form :model="editForm" ref="editForm" :size="size" :rules="rules.editForm" label-width="110px">
        <div class="drawer-header">
          <div class="header-title">
            <span>编辑用户组</span>
            <i class="el-icon-close k-drawer-close" @click="editFormVisiable = false"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-form-item label="用户组名称" prop="name">
            <el-input v-model="editForm.name" placeholder="请填写用户组名称"></el-input>
          </el-form-item>

          <el-form-item label="用户组等级" prop="level">
            <el-select v-model="editForm.level" placeholder="请选择用户组等级">
              <el-option label="一级分类" value="LEVEL_ONE"></el-option>
              <el-option label="二级分类" value="LEVEL_TWO"></el-option>
              <el-option label="三级分类" value="LEVEL_THREE"></el-option>
              <el-option label="四级分类" value="LEVEL_FOUR"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="关联用户组" prop="pid">
            <el-select v-model="editForm.pid" placeholder="请选择关联用户组">
              <el-option label="顶级用户组" value="0"></el-option>
              <el-option v-for="item in groups_options" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否开启" prop="status">
            <el-radio v-model="editForm.status" label="STATUS_NORMAL">正常</el-radio>
            <el-radio v-model="editForm.status" label="STATUS_CLOSE">关闭</el-radio>
          </el-form-item>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" @click="handleTableEdit" :size="size">提交</el-button>
          <el-button :size="size" @click="editFormVisiable = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer custom-class="k-drawer" :visible.sync="rolesFormVisiable" direction="rtl" size="70%">
      <el-form :model="rolesForm" :size="size" label-width="80px">
        <div class="drawer-header">
          <div class="header-title">
            <span>为用户组分配角色</span>
            <i class="el-icon-close k-drawer-close" @click="rolesFormVisiable = false"></i>
          </div>
        </div>
        <div class="drawer-content">
          <el-button type="text" @click="handleTableSlectAll('rolesForm')">全选</el-button>
          <el-button type="text" @click="handleTableCancelAll('rolesForm')">全不选</el-button>
          <el-button type="text" @click="handleTableSelectChange('rolesForm')">反选</el-button>
          <el-main :style="apiMainHeight">
            <el-form-item :label="item.name" prop="roles" :key="index" v-for="(item, index) in options.roles">
              <el-checkbox-group v-model="rolesForm.relations">
                <el-checkbox v-for="value in item.children" :label="value.id" :key="value.id">{{ value.name
                }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-main>
        </div>
        <div class="drawer-footer">
          <el-button type="primary" @click="handleTableRoles" :size="size">提交</el-button>
          <el-button :size="size" @click="rolesFormVisiable = false">取消</el-button>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>
export default {
  props: ['info'],
  data () {
    return {
      loading: '',
      size: 'mini',
      groups_options: [],
      actionsFormVisiable: false,
      rolesFormVisiable: false,
      addFormVisiable: false,
      editFormVisiable: false,
      checkSkVisiable: false,
      activeName: 'first',
      options: {
        roles: []
      },
      searchForm: {
        type: 'name',
        name: '',
        level: ''
      },
      resetSearch: {
        type: 'name',
        name: '',
        level: ''
      },
      addForm: {
        name: '',
        level: 'LEVEL_ONE',
        status: 'STATUS_NORMAL',
        pid: '0'
      },
      editForm: {
        name: '',
        level: 'LEVEL_ONE',
        status: 'STATUS_NORMAL',
        pid: ''
      },
      rolesForm: {
        id: '',
        relations: []
      },
      checkSkForm: {
        id: '',
        secret_key: ''
      },
      checkSk: {
        show: false,
        text: '显示'
      },
      rules: {
        searchForm: {
          type: [
            {
              required: true,
              message: '请选择搜索类型',
              trigger: ['change', 'blur']
            }
          ],
          name: [
            {
              max: 50,
              message: '请填写正确的用户组名称，长度不超过 50',
              trigger: ['change', 'blur']
            }
          ]
        },
        addForm: {
          name: [
            {
              required: true,
              message: '请填写正确的用户组名称，长度不超过 50',
              trigger: ['change', 'blur']
            },
            {
              max: 50,
              message: '请填写正确的用户组名称，长度不超过 50',
              trigger: ['change', 'blur']
            }
          ],
          level: [
            {
              required: true,
              message: '请选择搜索用户组等级',
              trigger: ['change', 'blur']
            }
          ],
          status: [
            {
              required: true,
              message: '请选择搜索用户组状态',
              trigger: ['change', 'blur']
            }
          ],
          pid: [
            {
              required: true,
              message: '请选择等级用户组',
              trigger: ['change', 'blur']
            }
          ]
        },
        editForm: {
          name: [
            {
              required: true,
              message: '请填写正确的用户组名称，长度不超过 50',
              trigger: ['change', 'blur']
            },
            {
              max: 50,
              message: '请填写正确的用户组名称，长度不超过 50',
              trigger: ['change', 'blur']
            }
          ],
          level: [
            {
              required: true,
              message: '请选择搜索用户组等级',
              trigger: ['change', 'blur']
            }
          ],
          status: [
            {
              required: true,
              message: '请选择搜索用户组状态',
              trigger: ['change', 'blur']
            }
          ],
          pid: [
            {
              required: true,
              message: '请选择等级用户组',
              trigger: ['change', 'blur']
            }
          ]
        }
      },
      tableData: {
        total: 0,
        per_page: 15,
        current_page: 1,
        last_page: 0,
        data: []
      }
    }
  },
  computed: {
    tableHeight: function () {
      return window.innerHeight - 320
    },
    apiMainHeight: function () {
      var height = window.innerHeight - 200
      return {
        height: height + 'px',
        border: '1px solid #DCDFE6',
        'margin-bottom': '10px'
      }
    }
  },
  methods: {
    getGroupByUserId: function () {

      this.$api.get('group/getGroupsByUser', { 'groupEdit': 1 }, res => {
        if (res.code == 0) {
          this.groups_options = res.data
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    reset: function () {
      this.searchForm = this.resetSearch
    },
    handleSearch: function (params, page, prop, order) {
      this.$refs['searchForm'].validate(
        function (valid) {
          if (valid) {
            this.loading = true

            var param = Object.assign({}, params)

            param['page'] = page ? page : 1
            param['prop'] = prop ? prop : 'id'
            param['order'] = order ? order : 'desc'

            this.$api.http.get('management/getGroupList', param).then(res => {
              if (res.code === 0) {
                this.tableData = res.data
              } else {
                var message = res.message
                  ? res.message
                  : '查询应用列表信息失败！'
                this.$message({
                  showClose: true,
                  message: message,
                  type: 'error'
                })
              }
              this.loading = false
            })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },

    // 执行查询
    doSearch: function (event) {
      this.handleSearch(this.searchForm, 1, '', '')
    },

    // 排序
    sortChange: function (e) {
      var order
      var prop = e.prop
      if (e.order == 'ascending') {
        order = 'asc'
      } else if (e.order == 'descending') {
        order = 'desc'
      } else {
        prop = this.resetSearch.prop
        order = this.resetSearch.order
      }
      this.handleSearch(this.searchForm, 1, prop, order)
    },

    // 改变当前页 page
    handleCurrentChange: function (val) {
      this.handleSearch(this.searchForm, val)
    },

    // 全选
    handleTableSlectAll: function (form) {
      switch (form) {
        case 'rolesForm':
          var roles = []
          var item
          for (var i in this.options.roles) {
            item = this.options.roles[i]

            for (var index in item.children) {
              roles.push(item.children[index].id)
            }
          }
          this.rolesForm.relations = roles
          break
      }
    },

    // 反选
    handleTableSelectChange: function (form) {
      switch (form) {
        case 'rolesForm':
          var roles = []
          var item
          for (var i in this.options.roles) {
            item = this.options.roles[i]

            for (var index in item.children) {
              if (
                this.rolesForm.relations.indexOf(item.children[index].id) < 0
              ) {
                roles.push(item.children[index].id)
              }
            }
          }
          this.rolesForm.relations = roles
          break
      }
    },

    // 全不选
    handleTableCancelAll: function (form) {
      switch (form) {
        case 'rolesForm':
          this.rolesForm.relations = []
          break
      }
    },

    // 添加用户组
    handelAddOpen: function () {
      this.addFormVisiable = true
      this.getGroupByUserId()
    },

    // 添加用户组
    handelAdd: function () {
      this.$refs['addForm'].validate(
        function (valid) {
          if (valid) {
            this.loading = true
            this.$api.http
              .post('management/groupAdd', this.addForm)
              .then(res => {
                var message = '添加用户组成功！'
                var msgType = 'success'
                if (res.code === 0) {
                  this.tableData.data.unshift(res.data)
                } else {
                  message = res.message ? res.message : '添加用户组失败！'
                  msgType = 'error'
                }
                this.$message({
                  showClose: true,
                  message: message,
                  type: msgType
                })
                this.loading = false
                this.addFormVisiable = false
              })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },

    // 打开编辑用户组弹窗
    handleTableEditOpen: function (row) {
      this.loading = true

      this.$api.http
        .get('management/getGroupInfo', { id: row.id })
        .then(res => {
          if (res.code === 0) {

            this.editForm = res.data
            if (res.data.pid == 0) {
              this.editForm.pid = '' + res.data.pid
            }

            this.editFormVisiable = true
            this.getGroupByUserId()
          } else {
            var message = res.message ? res.message : '获取用户组失败！'
            var msgType = 'error'
            this.$message({
              showClose: true,
              message: message,
              type: msgType
            })
          }

          this.loading = false
        })
    },

    // 编辑用户组
    handleTableEdit: function () {
      this.$refs['editForm'].validate(
        function (valid) {
          if (valid) {
            this.loading = true
            this.$api.http
              .post('management/editGroup', this.editForm)
              .then(res => {
                if (res.code === 0) {
                  var data = this.tableData.data
                  data.forEach(
                    function (item, index) {
                      if (item.id == res.data.id) {
                        this.$set(data, index, res.data)
                      }
                    }.bind(this)
                  )
                } else {
                  var message = res.message ? res.message : '编辑用户组失败！'
                  var msgType = 'error'
                  this.$message({
                    showClose: true,
                    message: message,
                    type: msgType
                  })
                }
                this.editFormVisiable = false
                this.loading = false
              })
          } else {
            this.$message({
              showClose: true,
              message: '请填写正确的信息！',
              type: 'warning'
            })
          }
        }.bind(this)
      )
    },

    // 打开编辑用户组弹窗
    handleTableRolesOpen: function (row) {
      this.loading = true
      this.$api.http
        .get('management/getGroupRoles', { id: row.id })
        .then(res => {
          if (res.code === 0) {
            this.options.roles = res.data.roles
            this.rolesForm.relations = res.data.relations
            this.rolesForm.id = res.data.group.id
            this.rolesFormVisiable = true
          } else {
            var message = res.message ? res.message : '查询用户组信息失败！'
            this.$message({
              showClose: true,
              message: message,
              type: 'error'
            })
          }
          this.loading = false
        })
    },

    // 编辑用户组
    handleTableRoles: function () {
      this.loading = true
      this.$api.http
        .post('management/getGroupRolesAdd', this.rolesForm)
        .then(res => {
          var message = '修改用户组角色权限信息成功！'
          var msgType = 'success'
          if (res.code === 0) {
            this.rolesFormVisiable = false
          } else {
            message = res.message ? res.message : '修改用户组角色权限信息失败！'
            msgType = 'error'
          }
          this.loading = false
          this.$message({
            showClose: true,
            message: message,
            type: msgType
          })
        })
    },

    // 删除用户组
    handleTableDelete: function (row) {
      this.$confirm('此操作将永久删除该用户组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(
          function () {
            this.loading = true
            this.$api.http
              .post('management/groupDelete', { id: row.id })
              .then(res => {
                var message = '删除用户组信息成功！'
                var msgType = 'success'
                if (res.code === 0) {
                  var data = this.tableData.data
                  data.forEach(
                    function (item, index) {
                      if (item.id == row.id) {
                        this.$delete(data, index)
                      }
                    }.bind(this)
                  )
                } else {
                  message = res.message ? res.message : '删除用户组信息失败！'
                  msgType = 'error'
                }
                this.loading = false
                this.$message({
                  showClose: true,
                  message: message,
                  type: msgType
                })
              })
          }.bind(this)
        )
        .catch(() => { })
    },
    // 生成查询参数
    makeParams: function (query) {
      var params = {}
      params['type'] = query.type ? query.type : this.resetSearch.type
      params['name'] = query.name ? query.name : this.resetSearch.name
      params['level'] = query.level ? query.level : this.resetSearch.level

      this.searchForm = params
      return params
    }
  },
  mounted: function () {
    var params = this.makeParams(this.$route.query)
    this.handleSearch(params)
  }
}
</script>